import xhrJson from '../utils/xhr-json';

/**
 *  Working with the network
 */

class Network {
    /**
     * Url
     * @param {String} link
     * @param {Object} data parameters
     * @returns {URL}
     */
    static getUrl(link, data = {}) {
        let url = new URL(link, window.location.origin);

        for (let key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                url.searchParams.set(key, data[key]);
            }
        }

        return url;
    }

    /**
     * Call
     * @param link
     * @param data
     * @param method
     * @returns {Promise<*|{}>}
     */
    static async call({link, data = {}, method = 'GET'}) {
        let param = {method};
        let url = method === 'POST' ? Network.getUrl(link) : Network.getUrl(link, data);

        if (method === 'POST') {
            let formData = new FormData();

            for (let i in data) {
                if (Object.prototype.hasOwnProperty.call(data, i)) {
                    if (typeof data[i] === 'object' && (
                        Object.prototype.toString.call(data[i]) === '[object FileList]' ||
                        Object.prototype.toString.call(data[i]) === '[object Object]' && i === 'files'
                    )) {
                        for (let index in data[i]) {
                            if (Object.prototype.hasOwnProperty.call(data[i], index)) {
                                formData.append('files[]', data[i][index]);
                            }
                        }
                    } else {
                        formData.append(i, data[i]);
                    }
                }
            }

            param.body = formData;
        }

        try {
            return await xhrJson(url, param);
        } catch (error) {
            return {};
        }
    }
}

export default Network;
